<template>
  <div id="app">
    <b-navbar
      fill
      variant="faded"
      type="light"
    >
      <b-navbar-brand>
        <b-row align-v="center">
          <img
            src="/static/images/titulka.jpg"
            height="120px"
          >
          <b-col>
            <h4><b>Kontakt: </b> misha.cards.order@gmail.com</h4>
            <h5><b>Poštovné: </b> 2 €</h5>
          </b-col>
        </b-row>
      </b-navbar-brand>
    </b-navbar>
    <b-row style="margin: 0">
      <b-nav
        vertical
        tabs
        style="padding-left: 5px, color: silver"
      >
        <b-nav-item to="/velkanoc">...Veľká Noc</b-nav-item>
        <b-nav-item to="/darceky">...DARČEKY</b-nav-item>
        <b-nav-item to="/valentin">...♥VALENTÍN♥</b-nav-item>
        <b-nav-item to="/magnetky">...magnetky</b-nav-item>
        <b-nav-item to="/visacky">...visačky</b-nav-item>
        <b-nav-item to="/kvietky">...kvietky</b-nav-item>
        <b-nav-item to="/narodeniny">...Narodeniny</b-nav-item>
        <b-nav-item to="/zvieratka">...zvieratká</b-nav-item>
        <b-nav-item to="/povolania">...povolania</b-nav-item>
        <b-nav-item to="/deticky">...pre detičky</b-nav-item>
        <b-nav-item to="/svadba">...♥svadba♥</b-nav-item>
        <b-nav-item to="/babatka">...pre bábätká</b-nav-item>
        <b-nav-item to="/vianoce">...❄Vianoce❄</b-nav-item>
      </b-nav>
      <router-view/>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "static/css/custom-bootstrap.scss";
  @import "bootstrap/scss/bootstrap.scss";
  @import "static/css/style.scss";
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue